
import { Button } from "@/components/ui/button";
import { AssessmentQuestion } from "./types";
import { useIsFirstAssessment } from "@/hooks/useIsFirstAssessment";
import { CompletionActions } from "./CompletionActions";

interface CompletionScreenProps {
  question: AssessmentQuestion;
  onFinish: () => void;
  onNextAssessment?: () => void;
  scoreIncrease?: number;
  moduleId?: string;
}

export function CompletionScreen({ question, onFinish, onNextAssessment, scoreIncrease = 15, moduleId }: CompletionScreenProps) {
  const isFirst = useIsFirstAssessment();
  const isA1 = moduleId === 'owner-readiness';

  return (
    <div className="text-center space-y-8 py-8 w-full max-w-4xl mx-auto min-h-[400px] flex flex-col justify-center">
      <div className="space-y-4">
        {isFirst && isA1 ? (
          <>
            <p className="text-lg text-muted-foreground max-w-lg mx-auto">
              Your mySuccession Score is now live on your dashboard.
            </p>
            <p className="text-lg text-muted-foreground max-w-lg mx-auto">
              This is your starting point — as you complete each assessment, your score will grow and we'll surface the key insights and gaps that give you a clear, actionable succession plan.
            </p>
          </>
        ) : (
          <>
            <p className="text-lg text-muted-foreground max-w-lg mx-auto">
              Thanks for sharing your perspective — you've just moved the needle.
            </p>
            <p className="text-lg text-muted-foreground max-w-lg mx-auto">
              Your mySuccession score has <span className="text-primary font-semibold">improved by {scoreIncrease}%</span>. That shift reflects the clarity you brought to your answers and gives us a stronger foundation to map out your next steps with confidence.
            </p>
          </>
        )}
      </div>
      
      <CompletionActions
        onNextAssessment={onNextAssessment || onFinish}
        onViewDashboard={onFinish}
      />
    </div>
  );
}
